import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import postUsage from "../util/postUsage";
import "./LandingPage.css";

class LandingPage extends Component {
  render () {
    postUsage("landing_page");
    return (
      <div className="Container">
        <Helmet>
          <title>Bioinformatics Hub: Landing Page</title>
        </Helmet>
        <div id="landing-header">
            <h1>Welcome to Bioinformatics Hub</h1>
            <Link to="/sequence/scan_motif" className="btn btn-lg btn-info">Visit Bioinformatics Hub</Link>
        </div>       
        <ul className="slideshow">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        </ul> 
      </div>
    );
  }
}

export default LandingPage;
